/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcGenerateV1TradeConfirmationsTaskState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_GENERATE_V1_TRADE_CONFIRMATIONS_TASK_STATE_ENTITY_NAME = 'ixc.generate.v1.TradeConfirmationsTask';
export const ixcGenerateV1TradeConfirmationsTaskStateEntity = new schema.Entity<IxcGenerateV1TradeConfirmationsTaskState>(IXC_GENERATE_V1_TRADE_CONFIRMATIONS_TASK_STATE_ENTITY_NAME, {}, { idAttribute: 'taskId' });

